export default __webpack_public_path__ + "static/media/Error.3d78e4c9.png";